import DOMPurify from 'dompurify'

import { cn } from '@rewardops/ui'
import { invertHex, type Section } from '@rewardops/utils'

import AdButton from './adButton'
import ContentfulImage from './contentfulImage'

type Props = {
  content: Section
}

function FullWidthPaneSmall(props: Props) {
  const { content } = props
  const {
    id,
    contentImages,
    headingText,
    content: textContent,
    linkText,
    productUrl,
    backgroundColor = 'FFFFFF',
  } = content
  const textColor = invertHex(backgroundColor)

  return (
    <div
      className="overflow-y-hiddenp-10 col-span-2 flex flex-col pb-0"
      style={{
        backgroundColor: `#${backgroundColor || 'FFFFFF'}`,
        color: textColor,
      }}
    >
      <div className="m-6">
        {headingText && (
          <div className="text-3xl font-semibold">{headingText}</div>
        )}
        {textContent && (
          <div className="mt-3 font-normal">
            <span
              className="[&_a:hover]:underline [&_a]:text-tenant-primary-color"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textContent),
              }}
            />
          </div>
        )}
        {linkText && productUrl ? (
          <AdButton
            id={id}
            href={productUrl}
            aria-label={`${linkText}: ${headingText}`}
          >
            {linkText}
          </AdButton>
        ) : undefined}
      </div>
      <ContentfulImage
        content={contentImages?.[0]?.image}
        label={headingText ?? 'Ad Image'}
        className={cn('h-auto w-auto')}
        height="auto"
        width="auto"
        maxHeight="26rem"
        maxWidth="min(32rem, 100%)"
      />
    </div>
  )
}

export default FullWidthPaneSmall
